import { Button } from 'reactstrap'
import { FaFileExport } from 'react-icons/fa'
import s from '../SidebarButtons.scss'

const SendToReviewBtn = ({ toggleSendForInternalReviewModal }) => (
  <Button className={s.sidebarButton} onClick={toggleSendForInternalReviewModal}>
    <FaFileExport style={{ position: 'relative', bottom: 2, right: 4 }} />
    Send for Internal Review
  </Button>
)

export default SendToReviewBtn
